// src/holidays/holidayBannerConfig.js
// Central config for holiday banners on the landing page

export const holidayBanner = {
  // Set to null or remove after the holiday
  active:
    new Date() >= new Date("2026-02-10") &&
    new Date() <= new Date("2026-02-14"),
  image: require("../assets/ValentinesDay.webp"),
  title: "Valentine's Day",
  subtitle:
    "Solo this Valentine's? Link up for arcade games, drinks, and better company! ❤️",
  cta: "Create a linkup",
};

// To handle a new holiday, update the dates, image, and text.
